<template>
  <!--    :disabled="!activationStore.isActivated"-->
  <v-btn v-if="!$isDirector || allowDirector" depressed class="mr-2" color="primary" @click="create">
    {{ $t('actions.create') }}
    <v-icon right dark> mdi-plus-thick </v-icon>
  </v-btn>
</template>

<script>
import { activationStore } from '@/utils/helpers';
export default {
  name: 'CreateButton',
  props: {
    // Drejtoret jane te bllokuar nga krijimi si rregull; kjo e hap
    // vetem aty ku u lejohet shprehimisht (p.sh. njoftimet).
    allowDirector: { type: Boolean, default: false },
  },
  setup() {
    return { activationStore };
  },
  methods: {
    create() {
      this.$emit('create');
    },
  },
};
</script>
